import { render } from "./UserEvaluation.vue?vue&type=template&id=bd7fcdb2"
import script from "./UserEvaluation.vue?vue&type=script&lang=js"
export * from "./UserEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__